/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum DownloadEnum {
    WAITING = 0,
    DOWNLOADING = 1,
    DOWNLOADED = 2,
    CONNECTED = 3,
    SETUP = 4,
    SETUP_COMPLETE = 5,
    ADOPTED = 6
}
